<template>
  <v-data-table
      :headers="headers"
      :items="[single_break.item]"
      hide-default-header
      hide-default-footer
      mobile-breakpoint="100"
  >
    <template v-slot:item="{item}">
        <tr>
            <td>Odometer Break Start</td>
            <td>
                <strong v-if="!no_data.includes(item.start_odometer)">
                    {{item.start_odometer}}
                </strong>
                <em v-else class="grey--text">No Data</em>
            </td>
            <td>Odometer Break End</td>
            <td>
                <strong v-if="!no_data.includes(item.end_odometer)">
                    {{item.end_odometer}}
                </strong>
                <em v-else class="grey--text">No Data</em>
            </td>
        </tr>
        <tr>
            <td>Start Break Time</td>
            <td>
                <strong v-if="!no_data.includes(item.start_time)">
                    {{onlyTime(item.start_time)}}
                </strong>
                <em v-else class="grey--text">No Data</em>
            </td>
            <td>End Break Time</td>
            <td>
                <strong v-if="!no_data.includes(item.end_time)">
                    {{onlyTime(item.end_time)}}
                </strong>
                <em v-else class="grey--text">No Data</em>
            </td>
        </tr>
        <tr>
            <td>Start Break Notes</td>
            <td>
                <strong v-if="!no_data.includes(item.start_note)">
                    {{item.start_note}}
                </strong>
                <em v-else class="grey--text">No Data</em>
            </td>
            <td>End Break Notes</td>
            <td>
                <strong v-if="!no_data.includes(item.end_note)">
                    {{item.end_note}}
                </strong>
                <em v-else class="grey--text">No Data</em>
            </td>
        </tr>
    </template>
    <template v-slot:footer>
        <v-divider></v-divider>
        <v-layout class="py-2 px-6">
            <v-spacer></v-spacer>
            <v-btn text large background="warning" color="error" @click="remove(single_break.index)">Delete</v-btn>
            <v-btn text large background="#e0f7fa" color="primary" @click="edit(single_break.index)">Edit</v-btn>
        </v-layout>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'Break',
  props: ['single_break'],
  data() {
    return {
      item: [],
      no_data: [null, '', undefined, 'null'],
      headers: [
          { text: 'Results', value: 'results', sortable: false },
          { text: 'Results', value: 'results', sortable: false },
          { text: 'Results', value: 'results', sortable: false },
          { text: 'Results', value: 'results', sortable: false }
      ],
    }  
  },
  methods: {
    edit(index) {
      this.$emit('edit', index)
    },
    remove(index) {
      this.$emit('delete', index)
    },
    onlyDate(date) {
        return moment(date).format('YYYY-MM-DD');
    },
    onlyTime(date) {
        return moment(date).format('HH:mm');
    },
  }
}
</script>
